import React from 'react';
import FlexibleDatesRepricingMessageDecorator, {
  FlexibleDatesRepricingMessagePositionType,
} from '@components/Results/Components/FlexibleDates/FlexibleDatesRepricingMessage/FlexibleDatesRepricingMessageDecorator';
import PrimeDayItineraryHeaderRevamp from '@components/Results/Components/ThreeColumnsItinerary/Campaigns/PrimeDay/PrimeDayItineraryHeader';
import HighlightedDecorator from '@components/Results/Components/ThreeColumnsItinerary/HighlightedDecorator/HighlightedDecorator';

const ThreeColumnsItineraryDecorationBase = ({
  Component,
  highlightedType,
  withPrimeDayHeader,
  type,
  sx,
  children,
  ...props
}) => {
  return (
    <FlexibleDatesRepricingMessageDecorator
      position={FlexibleDatesRepricingMessagePositionType.belowCard}
    >
      {withPrimeDayHeader && <PrimeDayItineraryHeaderRevamp />}
      <HighlightedDecorator
        CardComponent={Component}
        type={type}
        highlightedType={highlightedType}
        {...props}
        sx={sx}
      >
        {children}
      </HighlightedDecorator>
    </FlexibleDatesRepricingMessageDecorator>
  );
};

export default ThreeColumnsItineraryDecorationBase;
